import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@nextui-org/react';

interface UnsavedChangesModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onLeave: () => void;
}

export default function UnsavedChangesModal({
  isOpen,
  onCancel,
  onLeave,
}: UnsavedChangesModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onCancel} size="md" placement="center">
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">
          Unsaved changes
        </ModalHeader>
        <ModalBody>
          <p>
            You have unsaved changes to the name or prompt. If you leave now, all
            changes will be lost.
          </p>
        </ModalBody>
        <ModalFooter className="justify-between border-t mt-4">
          <Button variant="bordered" onPress={onCancel}>
            Cancel
          </Button>
          <Button color="danger" onPress={onLeave}>
            Leave page
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
